export default __webpack_public_path__ + "static/media/garden-03.4fddc1de.jpg";